import React from 'react';

const Logo = ({ className = "h-8 w-auto", showText = true, textSize = "text-xl" }) => {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0 hover:scale-105 transition-transform duration-200"
      >
        {/* Background circle with gradient */}
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3B82F6" />
            <stop offset="100%" stopColor="#1E40AF" />
          </linearGradient>
          <linearGradient id="accentGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#10B981" />
            <stop offset="100%" stopColor="#059669" />
          </linearGradient>
        </defs>
        
        {/* Main circle background */}
        <circle cx="16" cy="16" r="15" fill="url(#logoGradient)" stroke="#1E40AF" strokeWidth="1"/>
        
        {/* API connection nodes */}
        <circle cx="8" cy="12" r="2" fill="url(#accentGradient)" />
        <circle cx="24" cy="12" r="2" fill="url(#accentGradient)" />
        <circle cx="16" cy="24" r="2" fill="url(#accentGradient)" />
        
        {/* Connection lines representing API calls */}
        <path d="M10 12 L22 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
        <path d="M8 14 L16 22" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
        <path d="M24 14 L16 22" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
        
        {/* Central hub representing the testing engine */}
        <circle cx="16" cy="16" r="3" fill="#ffffff" />
        <circle cx="16" cy="16" r="1.5" fill="url(#logoGradient)" />
        
        {/* Small testing indicators */}
        <circle cx="12" cy="8" r="1" fill="#10B981" />
        <circle cx="20" cy="8" r="1" fill="#10B981" />
      </svg>
      
      {showText && (
        <div className="flex flex-col">
          <span className={`${textSize} font-bold text-gray-900 leading-none tracking-tight`}>
            EJBED
          </span>
          <span className="text-xs text-primary-600 font-medium tracking-wide">
            Testing Tomorrow, Today
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo; 